<template>
	<div class="country_entity flex flex-column" style="width: 100%">
		<TVInputSelect
			id="countryofRecidency"
			v-model="countryofRecidency"
			name="countryofRecidency"
			:label="$t('application.apCountryRL')"
			:placeholder="$t('application.apCountryRP')"
			:options="countryOptions"
			style="width: 100%"
			v-if="!isCountryEurope && showCountry"
			:tooltip-message="$t('register.countryTooltip')"
			:tooltip-dir-desk="tooltipDirection"
			tooltip-dir-mobile="top"
			:tooltip-max-width="220"
		/>

		<TVInputSelectImg
			id="entity"
			v-if="showSelectEnt"
			v-model="entity"
			name="entity"
			:label="$t('register.entity')"
			:placeholder="$t('register.entityPLaceholder')"
			:options="entityOptions"
			:tooltip-message="$t('register.entityTooltip')"
			:tooltip-dir-desk="tooltipDirection"
			tooltip-dir-mobile="top"
			:tooltip-max-width="220"
			style="width: 100%"
		/>
	</div>
</template>

<script>
import { ref, onMounted, computed, watch } from 'vue'
import TVInputSelect from '../../../modules/ui/TVInputSelect.vue'
import TVInputSelectImg from '../../../modules/ui/TVInputSelectImg.vue'
import axios from 'axios'
import { EUROPA_COUNTRIES } from '@/plugins/countries'

export default {
	name: 'CountryEntity',
	emits: ['updateCountryEntity'],
	props: {
		showCountry: {
			type: Boolean,
			default: true,
		},
	},
	components: {
		TVInputSelect,
		TVInputSelectImg,
	},
	setup(props, { emit }) {
		const countryOptions = ref([])
		const countryofRecidency = ref(null)
		const entity = ref(null)
		const initialEntity = ref(null)
		const isInitialLoad = ref(true)
		const ipLocale = ref(null)
		const ib_id = ref(null)
		const ib_tree = ref(null)
		const entityStorage = ref(null)
		let entityOptions = ref(null)
		const showSelectEnt = ref(true)
		const entityLatam = ref([
			{
				text: 'Tradeview Financial Markets S.A.C. (Peru)', //SAC
				value: 'LATAM',
			},
		])
		const entityLtd = ref([
			{
				text: 'Tradeview Ltd. (CIMA)', //LTD
				value: 'LTD',
			},
		])
		const entityGlobal = ref([
			{
				text: 'TVM Global Ltd. (FSA, Labuan)', //GLB
				value: 'GLOBAL',
			},
		])
		const entityMena = ref([
			{
				text: 'Tradeview Financial Markets S.A.C. (MENA)', //MENA
				value: 'MENA',
			},
		])
		const entityJapan = ref([
			{
				text: 'Tradeview Financial Markets S.A.C. (Japan)', //JP
				value: 'JAPAN',
			},
		])

		onMounted(async () => {
			await fetchLocalIP()
			await loadCountryEntities()
			emitCountryEntityUpdate()
			setTimeout(() => {
				changeEntityOptions()
			}, 1000)

			isInitialLoad.value = false
		})

		const changeEntityOptions = () => {
			entityOptions.value = []
			entityStorage.value = localStorage.getItem('entityOptions')
			ib_id.value = localStorage.getItem('ib_id')
			ib_tree.value = localStorage.getItem('ib_tree')

			if (
				entityStorage.value &&
				entityStorage.value !== undefined &&
				entityStorage.value !== 'undefined' &&
				(ib_id.value === null || ib_id.value === 'undefined') &&
				(ib_tree.value === null || ib_tree.value === 'undefined')
			) {
				let entitiesArray = entityStorage.value.split(',')
				let selectedEntities = []

				const entityMap = {
					sac: entityLatam.value,
					ltd: entityLtd.value,
					glb: entityGlobal.value,
					jp: entityJapan.value,
					mena: entityMena.value,
				}

				entitiesArray.forEach((entity) => {
					const matchedEntity = entityMap[entity.trim().toLowerCase()]
					if (matchedEntity) {
						selectedEntities.push(...matchedEntity)
					}
				})

				entityOptions.value = selectedEntities

				if(entitiesArray.length > 1){
					showSelectEnt.value = true
				}else{
					showSelectEnt.value = false
					entity.value = entityOptions.value[0].value
				}

			} else {
				if (
					(ib_id.value === null || ib_id.value === 'undefined') &&
					(ib_tree.value === null || ib_tree.value === 'undefined')
				) {
					const result = countryOptions.value.filter(
						(country) => country.value === countryofRecidency.value,
					)

					if (result.length > 0) {
						initialEntity.value = result[0].entities[0].value
					}
					entityOptions.value = result.length > 0 ? result[0].entities : []
				} else {
					entityOptions.value = entityLatam.value
				}
			}
		}

		const isCountryEurope = computed(() => {
			const isEurope = EUROPA_COUNTRIES.some(
				(country) => country.value === countryofRecidency.value,
			)
			const isIpLocaleEurope = EUROPA_COUNTRIES.some(
				(country) => country.value === ipLocale.value,
			)
			return isEurope && isIpLocaleEurope
		})

		const loadCountryEntities = async () => {
			try {
				const { data } = await axios.get(process.env.VUE_APP_CABINET_COUNTRIES);
				countryOptions.value = data.body
			} catch (error) {
				console.error('Error fetching data:', error)
			}
		}

		const fetchLocalIP = async () => {
			try {
				const response = await fetch('https://dcsz5gywka2h4.cloudfront.net/')
				if (!response.ok) {
					throw new Error('Network response was not ok')
				}
				ipLocale.value = await response.text()
				countryofRecidency.value = ipLocale.value
			} catch (error) {
				console.error('Error fetching data:', error)
			}
		}

		const emitCountryEntityUpdate = () => {
			emit('updateCountryEntity', {
				countryofRecidency: countryofRecidency.value,
				entity: entity.value,
				initialEntity: initialEntity.value,
				isCountryEurope: isCountryEurope.value,
			})
		}

		watch([countryofRecidency, entity, initialEntity], () => {
			if (!isInitialLoad.value) {
				emitCountryEntityUpdate()
			}

			watch(countryofRecidency, () => {
				changeEntityOptions()
			})
		})

		return {
			countryOptions,
			entityOptions,
			countryofRecidency,
			entity,
			isCountryEurope,
			ipLocale,
			ib_id,
			ib_tree,
			entityLatam,
			changeEntityOptions,
			entityStorage,
			entityLtd,
			entityGlobal,
			entityMena,
			entityJapan,
			showSelectEnt
		}
	},
}
</script>